import { FormField } from '@/types';
import Input from '@components/Form/Input';

function EmailField(props: FormField) {
  const {
    label,
    clean_name: cleanName,
    field_type: fieldType,
    help_text: helpText,
    required,
    infotext,
    min_chars: minChars,
    max_chars: maxChars,
    pattern,
  } = props;

  return (
    <Input
      label={label}
      type={fieldType}
      id={cleanName}
      placeholder={helpText}
      required={required}
      infotext={infotext}
      min_chars={minChars}
      max_chars={maxChars}
      pattern={pattern}
    />
  );
}

export default EmailField;
